import type { Page, Reference } from '@ps/web-martech-cms-types';
import { DismissIcon, StarsButton, useResolver } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { useLocation } from 'react-router';

import { useCMSReference } from '@swf/cms';
import StarsNavigationItem from '@swf/components/StarsNavigation/StarsNavigationItem';
import Arrow from '@swf/core/assets/icons/arrow.svg';

import styles from './CMSNavigationSubmenuItem.scss';

interface Props {
  pageRef?: Reference[];
  url?: string;
  resolverTag?: string;
  heading?: string;
  className: string;
  itemCount?: number;
  closeMenu?: boolean;
  onSelect: () => void;
}

const CMSNavigationSubmenuItem: React.FC<Props> = ({
  pageRef,
  heading,
  url,
  resolverTag,
  className,
  itemCount,
  closeMenu,
  onSelect
}) => {
  const page = useCMSReference<Page>(pageRef?.[0]);
  const { pathname } = useLocation();
  const resolverLink = useResolver(resolverTag);
  const href = url || resolverLink || page?.url;

  return (
    <StarsNavigationItem
      href={href}
      className={classNames(className, {
        [styles.menuItemActive]: pathname === href,
        [styles.noHover]: !href
      })}
      activeClassName={styles.menuItemActive}
      isActive={() => pathname === href}
      onClick={() => href && onSelect()}
    >
      {heading}
      {closeMenu && (
        <StarsButton
          variant="text"
          className={styles.close}
          icon={<DismissIcon />}
          onTouchStart={(e: React.TouchEvent) => {
            e.stopPropagation();
            onSelect();
          }}
        />
      )}
      {!closeMenu && href && <Arrow className={styles.arrow} width={15} height={15} />}
      {itemCount && <span className={styles.itemCount}>{itemCount}</span>}
    </StarsNavigationItem>
  );
};

export default CMSNavigationSubmenuItem;
